import React from 'react';
import PropTypes from 'prop-types';
import { getRangeBackgroundStyle } from '../audioPlayerHelper';
import { STYLES } from '../AudioPlayerConstants';

const { DEFAULT_BLUE_COLOR, WHITE } = STYLES;

const Volume = ({ currentVolume, setVolume, filledColor, unfilledColor }) => (
    <div className="volume">
        <i className={currentVolume === 0 ? 'icon-v2-mute' : 'icon-v2-audio'} />
        <div className="volume-input-wrapper">
            <input
                type="range"
                className="volume-input"
                value={currentVolume}
                style={{
                    background: getRangeBackgroundStyle(currentVolume, unfilledColor, filledColor),
                }}
                min="0"
                max="100"
                step="1"
                onChange={setVolume}
            />
        </div>
    </div>
);

Volume.defaultProps = {
    currentVolume: 100,
    setVolume: () => {},
    filledColor: DEFAULT_BLUE_COLOR,
    unfilledColor: WHITE,
};

Volume.propTypes = {
    filledColor: PropTypes.string,
    unfilledColor: PropTypes.string,
    currentVolume: PropTypes.number,
    setVolume: PropTypes.func,
};

export default Volume;
